<template>
  <div>
    <div class="col s12 m6 l4">
      <div class="card sticky-action" style="width:100%;">
        <table>
          <div @submit.prevent="Get_publ_intermediate_DB">
            <caption class="messageoutput" >ВЫГРУЗКА ДАННЫХ О ПУБЛИКАЦИЯХ ИЗ ПРОМЕЖУТОЧНОЙ БД (копия метаданных публикаций с аффилиацией НГТУ из системы Scopus)</caption>
            <tr>
              <td colspan="3">
                <span class="form_description">
                Для выгрузки метаданных публикаций из промежуточной БД заполните форму ниже, затем нажмите на кнопку 'Сформировать отчет'.<br>
                После того, как отчет будет софрмирован, он поступит на указанную Вами электронную почту в формате DOC.<br>
                </span>
                <span class="colortext_red3">ВНИМАНИЕ! </span><span class="colortext_456">Перед формированием отчета убедитесь, что в Scopus не появились новые публикации (для этого выполните ЭТАП 1).</span>
              </td>
            </tr>
            <tr>
              <td>Год, за который требуется выгрузить публикации:
                <span class="input-field">
                  <span v-if="checked === 'no'">
                    <input type="number" v-model="yearPubl_inter_2" id="Year_0" name="tentacles" min="1500" max="9999" style="width:60px; height:18px;" class="card-content red-text" :class="{ invalid: ( $v.yearPubl_inter_2.$dirty && !$v.yearPubl_inter_2.required && checked === 'no') || ( $v.yearPubl_inter_2.$dirty && !$v.yearPubl_inter_2.minLength && checked === 'no') }"> г.
                    <small
                      class="helper-text invalid"
                      v-if="$v.yearPubl_inter_2.$dirty && !$v.yearPubl_inter_2.required && checked === 'no'"
                    >Поле год является обязательным для заполнения (формат данных: число)!
                    </small>
                    <small
                      class="helper-text invalid"
                      v-else-if="$v.yearPubl_inter_2.$dirty && !$v.yearPubl_inter_2.minLength && checked === 'no'"
                    >Год должен состоять из {{ $v.yearPubl_inter_2.$params.minLength.min }} цифр. Сейчас количество цифр: {{yearPubl_inter_2.length}} шт.
                    </small>
                  </span>
                </span>
                <span class="input-field">
                  <span v-if="checked === 'yes'">
                    c <input type="number" v-model="yearPubl_inter_1" id="Year_1" name="tentacles" min="1500" max="9999" style="width:60px; height:18px;" class="card-content red-text" :class="{ invalid: ( $v.yearPubl_inter_1.$dirty && !$v.yearPubl_inter_1.required && checked === 'yes') || ( $v.yearPubl_inter_1.$dirty && !$v.yearPubl_inter_1.minLength && checked === 'yes') }">
                    по <input type="number" v-model="yearPubl_inter_2" id="Year_2" name="tentacles" min="1500" max="9999" style="width:60px; height:18px;" class="card-content red-text" :class="{ invalid: ( $v.yearPubl_inter_2.$dirty && !$v.yearPubl_inter_2.required && checked === 'yes') || ( $v.yearPubl_inter_2.$dirty && !$v.yearPubl_inter_2.minLength && checked === 'yes') }"> гг.
                    <div>
                    <small
                      class="helper-text invalid"
                      v-if="$v.yearPubl_inter_1.$dirty && !$v.yearPubl_inter_1.required  && checked === 'yes'"
                    >Поле для ввода начала периода ('с') является обязательным для заполнения (формат данных: число)!
                    </small>
                    <small
                      class="helper-text invalid"
                      v-else-if="$v.yearPubl_inter_1.$dirty && !$v.yearPubl_inter_1.minLength  && checked === 'yes'"
                    >Год (поле 'с') должен состоять из {{ $v.yearPubl_inter_1.$params.minLength.min }} цифр. Сейчас количество цифр: {{yearPubl_inter_1.length}} шт.
                    </small>
                    </div>
                    <div>
                    <small
                      class="helper-text invalid"
                      v-if="$v.yearPubl_inter_2.$dirty && !$v.yearPubl_inter_2.required && checked === 'yes'"
                    >Поле для ввода окончания периода ('по') является обязательным для заполнения (формат данных: число)!!
                    </small>
                    <small
                      class="helper-text invalid"
                      v-else-if="$v.yearPubl_inter_2.$dirty && !$v.yearPubl_inter_2.minLength && checked === 'yes'"
                    >Год (поле 'по') должен состоять из {{ $v.yearPubl_inter_2.$params.minLength.min }} цифр. Сейчас количество цифр: {{yearPubl_inter_2.length}} шт.
                    </small>
                    </div>
                  </span>
                </span>
                <span>
                  <label><input v-model="checked" true-value="yes" false-value="no" id="checkbox" type="checkbox"/><span>Ввести временной диапазон</span></label>
                </span>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>E-mail адрес, на который поступит отчет после его формирования:
                  <span class="input-field">
                  <span>
                    <input type="email" v-model="emailReportTo" id="email_1" name="email" style="width:240px; height:18px;" placeholder="name@corp.nstu.ru" class="card-content red-text" :class="{ invalid: ( $v.emailReportTo.$dirty && !$v.emailReportTo.required ) || ( $v.emailReportTo.$dirty && !$v.emailReportTo.email ) }">
                    <small
                      class="helper-text invalid"
                      v-if="$v.emailReportTo.$dirty && !$v.emailReportTo.required && flag===0"
                    >Поле email является обязательным для заполнения!
                    </small>
                    <small
                      class="helper-text invalid"
                      v-else-if="$v.emailReportTo.$dirty && !$v.emailReportTo.email"
                    >Введите корректный email
                    </small>
                  </span>
                </span>
              </td>
              <td>
                <button :disabled="isButtonDisabledPubl" class="btn-small btn-primary light-blue" @click="Get_publ_intermediate_DB">Сформировать отчет<i class="material-icons right">receipt</i></button>
              </td>
            </tr>
          </div>
            <tr>
<!--              <td colspan="2">-->
              <div v-if="GetPublIntermediateDBstatus === 3">
                  <span class="messageoutput">Отчет формируется и поступит на указанную электронную почту ориентировочно через:
                   <span v-if="loading_32 === false" class="align_items">
                    <span class="preloader-wrapper small active">
                      <span class="spinner-layer spinner-blue-only">
                        <span class="circle-clipper left">
                          <span class="circle"></span>
                        </span><span class="gap-patch">
                        <span class="circle"></span>
                      </span><span class="circle-clipper right">
                        <span class="circle"></span>
                      </span>
                      </span>
                    </span>
                  </span>
                   <span v-if="hours_11 !== 0">
                     {{this.hours_11}} ч.
                   </span>
                    <span v-if="minutes_12 !== 0">
                     {{this.minutes_12}} мин.
                   </span>
<!--                   <span v-if="seconds_13 !== 0">-->
<!--                     {{this.seconds_13 }} сек.-->
<!--                   </span>-->
                 </span>
                <br>Для справки:<br>• В формируемом отчете публикации расположены в обратном порядке относительно их внесения в промежуточную БД, что позволяет учесть порядок их появления в Scopus и удобно сравнивать формируемые отчеты (ранее отсутствующие публикации отобразятся в начале отчета);<br>• перед каждой генерацией отчета выполняется проверка на наличие персональных идентификаторов 'Scopus AuthorID' в личных кабинетах тех сотрудников, у которых ранее это поле было пустым, а в работе была указана аффилиация с НГТУ. Применительно к отчету описанная операция выполняется для сопоставления авторов публикации к соответствующим подразделениям НГТУ.
                <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
              </div>
<!--              </td>-->
            </tr>
            <div v-if="GetPublIntermediateDBstatus === 34">
              <tr>
                <td class="messageoutput">
                  Публикаций за указанный период не найдено.
                  <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
                </td>
              </tr>
            </div>
            <div v-else-if="GetPublIntermediateDBstatus === 1">
              <tr>
                <td class="helper-text invalid">
                <span v-if="checked === 'no'">
                Введенный Вами формат даты ({{yearNameIntermdb}}) некорректен!
                </span>
                  <span v-if="checked === 'yes'">
                Введенный Вами диапазон и (или) формат дат(ы) ({{yearNameIntermdb}}) некорректен! Дата начала периода не должна совпадать или быть больше даты окончания периода.
                </span>
                </td>
              </tr>
            </div>
          <!--API ключ для доступа к серверной части приложения (Backend) некорректный.-->
          <div v-else-if="GetPublIntermediateDBstatus === 5">
            <tr>
              <td class="helper-text invalid">
                Ошибка доступа! API ключ для доступа к серверной части приложения (Backend) некорректный. Пожалуйста, обратитесь к администратору системы.
                <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
              </td>
            </tr>
          </div>
          <!--В процессе операции (на стороне backend) произошла ошибка. Пожалуйста, обратитесь к администратору системы.-->
          <div v-else-if="GetPublIntermediateDBstatus === 4">
            <tr>
              <td class="helper-text invalid">
                В процессе операции (на стороне backend) произошла ошибка. Пожалуйста, обратитесь к администратору системы.
                <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
              </td>
            </tr>
          </div>
          <!--Не удается подключиться к серверу.-->
          <div v-else-if="GetPublIntermediateDBstatus === 6">
            <tr>
              <td class="helper-text invalid">
                Не удается подключиться к серверу. Пожалуйста, попробуйте еще раз, сейчас или позже.
                <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
              </td>
            </tr>
          </div>
        </table>
      </div>
    </div>
  </div>
</template>

<style>
  .colortext_456 {
    color: #013f28;
    font-family: 'Times New Roman', Times, serif; /* Гарнитура текста */
    font-size: 110%; /* Размер шрифта в процентах */
  }
  .colortext_red3 {
    color: darkred;
    /*font-weight:bold;*/
    /*color: #cc2216;*/
    /*font-weight: bold;*/
    font-family: 'Times New Roman', Times, serif; /* Гарнитура текста */
    /*font-weight: normal; !* Нормальное начертание *!*/
    /*text-align:justify;*/
  }
  .align_items {
   align-items: center;
  }
  .messageoutput {
    font-family: 'Times New Roman', Times, serif; /* Гарнитура текста */
    color: #013f28;
    font-weight:bold;
  }
  .form_description{
    font-family: 'Times New Roman', Times, serif; /* Гарнитура текста */
    font-size: 120%; /* Размер шрифта в процентах */
    font-weight: normal; /* Нормальное начертание */
    color: #013f28;
    font-style: italic; /* Курсивное начертание */
  }
  /*table, th, td, tr {*/
  /*  border: 1px solid black;*/
  /*}*/
</style>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators'
import { KEY } from '../../keys.js'
import { URLB } from '../../url'
export default {
  data () {
    return {
      hours_11: 0, /* время выполнения операции */
      minutes_12: 0, /* время выполнения операции */
      // seconds_13: 0, /* время выполнения операции */
      loading_32: true,
      loading_table: true,
      isButtonDisabledPubl: false, /* блокировка нажатия кнопки 'Выгрузить публикации' ИЗНАЧАЛЬНО: активная */
      GetReportsData: [],
      yearPubl_inter_1: (new Date().getFullYear() - 1), /* года для ввода'  {{ date | date('year') }} */
      yearPubl_inter_2: new Date().getFullYear(), /* года для ввода' */
      checked: 'no', /* переключатель год или диапазон в гг - отслеживание выбора пользователя ("yes"/"no")  */
      XELSCODE: 0,
      yearNameIntermdb: '', /* формирование года для api (конкретный год или диапазон)' */
      emailReportTo: '',
      GetPublIntermediateDB: 0,
      GetPublIntermediateDBstatus: 0,
      flag: 0
    }
  },
  validations: {
    emailReportTo: {
      required, email
    },
    yearPubl_inter_1: {
      required,
      minLength: minLength(4)
    },
    yearPubl_inter_2: {
      required,
      minLength: minLength(4)
    }
  },
  methods: {
    Get_publ_intermediate_DB () {
      this.flag = 0
      this.hours_11 = 0
      this.minutes_12 = 0
      // this.seconds_13 = 0
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }
      this.loading_32 = false
      var yearNameIntermdb
      var emailReportTo
      // var yearname = this.year_publ[1]
      if (this.checked === 'no') {
        yearNameIntermdb = this.yearPubl_inter_2
      }
      if (this.checked === 'yes') {
        yearNameIntermdb = this.yearPubl_inter_1 + '-' + this.yearPubl_inter_2
      }
      emailReportTo = this.emailReportTo
      this.statusGetPublIntermediateDB = 0
      const apiKeyBack = KEY.APIKEY_BACKEND
      const urlBack = URLB.URL_BACKEND
      this.$http.get(`${urlBack}/api/content/report_creation_intermediate_db/date/${yearNameIntermdb}/email/${emailReportTo}?apiKey=${apiKeyBack}`)
        .then(response => {
          this.loading_32 = true
          // console.log(response.json())
          return response.json()
        })
        .catch(error => {
          console.log(error)
          this.GetPublIntermediateDBstatus = 6
        })
        .then(GetPublIntermediateDB => {
          this.GetPublIntermediateDB = GetPublIntermediateDB
          // console.log(GetPublIntermediateDB)
          this.statusGetPublIntermediateDB = GetPublIntermediateDB.X_ELS_CODE
          // console.log(GetPublIntermediateDB.file_name)
          if (this.statusGetPublIntermediateDB === 1) {
            this.GetPublIntermediateDBstatus = 1
            return
          }
          if (this.statusGetPublIntermediateDB === 3) {
            this.lenListPublId = Number(GetPublIntermediateDB.number_publications)
            // console.log(this.lenListPublId)
            // console.log(GetPublIntermediateDB)
            if (this.lenListPublId > 0) {
              this.hours_11 = Math.floor((this.lenListPublId * 22) / 60 / 60)
              this.minutes_12 = Math.ceil((this.lenListPublId * 22) / 60) - (this.hours_11 * 60)
              // this.seconds_13 = Math.floor((this.lenListPublId * 22) % 60)
              // this.resultLoadingApiPubl = this.hours + ':' + this.minutes + ':' + this.seconds
            }
            this.GetPublIntermediateDBstatus = 3
            return
          }
          if (this.statusGetPublIntermediateDB === 4) {
            this.GetPublIntermediateDBstatus = 4
            return
          }
          if (this.statusGetPublIntermediateDB === 5) {
            this.GetPublIntermediateDBstatus = 5
            return
          }
          if (this.statusGetPublIntermediateDB === 34) {
            this.GetPublIntermediateDBstatus = 34
          }
        })
    },
    cleaningForm () {
      this.yearPubl_inter_1 = (new Date().getFullYear() - 1) /* года для ввода'  {{ date | date('year') }} */
      this.yearPubl_inter_2 = new Date().getFullYear() /* года для ввода' */
      this.yearNameIntermdb = '' /* формирование года для api (конкретный год или диапазон)' */
      this.emailReportTo = ''
      this.checked = 'no' /* переключатель год или диапазон в гг - отслеживание выбора пользователя ("yes"/"no")  */
      this.GetPublIntermediateDBstatus = ''
      this.XELSCODE = 0
      this.loading_32 = true
      this.flag = 1
    }
  }
}
</script>
